import { Contact } from './contact'
import { FeathersModel } from './feathersModel'
import { StripTagsPipe } from '../shared/pipes/stripHtml.pipe'

type SmsMessageStatus = 'pending' | 'sending' | 'sent' | 'delivered' | 'failed' // TOdO: tohle neni doresene, nemam radsi ukladat v databazi nejakej enum nebo cislo nebo codelist?? stejne tak smsDirection...
type SmsMessageDirection = 'in' | 'out'

export class SmsMessage extends FeathersModel {
  static serviceName = 'sms-messages'

  contactId: number
  contact: Contact
  body: string
  number: string
  smsDirection: SmsMessageDirection
  smsStatus: SmsMessageStatus
  createdAt: Date

  sms_reads: any[]
  private readByCurrentUser = false

  updateFromProps(props): this {
    super.updateFromProps(props)
    this.body = new StripTagsPipe().transform(this.body)
    return this
  }

  turnSubresourcesIntoFrontendModels() {
    if (this.contact) this.contact = Contact.createFromProps(Contact, this.contact)
  }

  getName() {
    if (this.contact) {
      return this.contact.user.fullName()
    } else {
      return this.number
    }
  }

  humanizeDirection() {
    if (this.smsDirection === 'out') return 'Odchozí'
    if (this.smsDirection === 'in') return 'Příchozí'
  }

  static humanizeStatus(status: SmsMessageStatus) {
    switch (status) {
      case 'delivered':
        return 'Doručeno'
      case 'failed':
        return 'Chyba'
      case 'sent':
        return 'Odesláno'
      case 'sending':
        return 'Odesílá se'
      case 'pending':
        return 'Čeká na odeslání'
    }
  }

  getStatusHumanized() {
    return SmsMessage.humanizeStatus(this.smsStatus)
  }

  isRead() {
    if (this.smsDirection === 'out') return true
    return this.sms_reads?.length > 0
  }

  isReadByCurrentUser() {
    return this.readByCurrentUser
  }

  setReadByCurrentUser(value: boolean) {
    this.readByCurrentUser = value
    return this
  }
}
